import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { specraFocusRing } from '../ensigns/focus-ring';
import { SpecraKeyHint } from '../ensigns/key-hint';
import { SpecraText } from '../ensigns/typography';
/** Compact command-palette trigger from the Delivery top bar. */ export const SpecraSearchTrigger = /*#__PURE__*/ React.forwardRef(({ children = 'Search', className, icon, shortcut = '⌘K', type = 'button', ...props }, ref)=>/*#__PURE__*/ _jsxs("button", {
        className: cn('flex h-8 w-full min-w-0 items-center gap-2 rounded-md border border-transparent bg-muted px-2.5 text-left text-[length:var(--fs-ui-caption)] text-muted-foreground transition-colors hover:border-border-strong hover:text-foreground sm:w-48', specraFocusRing, className),
        ref: ref,
        type: type,
        ...props,
        children: [
            icon ? /*#__PURE__*/ _jsx("span", {
                className: "shrink-0 [&_svg]:size-3.5",
                children: icon
            }) : null,
            /*#__PURE__*/ _jsx(SpecraText, {
                as: "span",
                size: "caption",
                tone: "muted",
                children: children
            }),
            shortcut ? /*#__PURE__*/ _jsx(SpecraKeyHint, {
                className: "ml-auto",
                children: shortcut
            }) : null
        ]
    }));
SpecraSearchTrigger.displayName = 'SpecraSearchTrigger';
